import { z } from 'zod';

export const changeExpectedPaymentSettingPostRequestSchema = z.object({
  payment: z.string().optional(),
  reference: z.string(),
  value: z.string(),
});
